import { combineReducers } from 'redux';
import buttonFactory from './reducerButtonFactory';
import application from './reducerApplication';
import { reducer as reduxFormReducer } from 'redux-form';

const rootReducer = {
	application,
	buttonFactory,
	// form: customReduxFormReducer()
	form: reduxFormReducer
};


export default combineReducers(rootReducer);



// WEBPACK FOOTER //
// ./buttons/reducers/index.js